import React, { forwardRef, InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { defaultInputStyles } from './inputStyles';
import { IFieldDesignProps, IStyledFieldDesignProps } from './types';

interface IProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>,
    IFieldDesignProps {
  onChange?: (value: string) => void;
}

const Container = styled.input<IStyledFieldDesignProps>`
  ${defaultInputStyles}
`;

export default forwardRef<HTMLInputElement, IProps>(
  ({ type = 'text', onChange, hasError, ...props }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <Container
        {...props}
        ref={ref}
        type={type}
        onChange={handleChange}
        $hasError={hasError}
      />
    );
  },
);
